<template>
  <div class="layout-default">
    <main class="layout-default__main">
      <HeroSection />
      <TopicsSection />
    </main>

    <footer class="layout-default__footer">
      <div class="links-wrapper">
        <a href="http://playkids.com/app" target="_blank" class="layout-default__footer__playkids-link">
          PlayKids
        </a>
        <div class="links-container">
          <ul>
            <li>
              <a id="checkout-bottom-cta-termos-de-uso" href="https://policies.playkidsapp.com/pt/tos" target="_blank">
                \ Termo de Uso
              </a>
            </li>
            <li>
              <a id="checkout-bottom-cta-politica-de-privacidade" href="https://policies.playkidsapp.com/pt/privacy" target="_blank">
                \ Política de Privacidade
              </a>
            </li>
            <li>
              <a id="checkout-bottom-cta-politica-de-cookies" href="https://policies.playkidsapp.com/pt/cookie" target="_blank">
                \ Política de Cookies
              </a>
            </li>
          </ul>
          <a class="kid-safe-icon" href="https://www.kidsafeseal.com/certifiedproducts/movile_playkids_app.html" target="_blank">
            <img border="0" alt="PlayKids - Learn Through Play is certified by the kidSAFE Seal Program."
            src="https://www.kidsafeseal.com/sealimage/392214569732409164/movile_playkids_app_extralarge_whitetm.png">
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Home'
}
</script>

<style lang="scss" scoped>
footer {
  .links-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;

    .links-container {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;

      ul {
        margin: 0;
        padding: 0;
        display: flex;
        flex-direction: column;
        list-style-type: none;
        margin-top: 2rem;

        li {
          margin-bottom: 1em;
          a {
            font-family: Mikado, sans-serif;
            font-weight: 300;
            font-style: normal;
            font-size: 14px;
            line-height: 20px;
            color: #fff;
            text-decoration: none;
            &:hover {
              text-decoration: underline;
            }
          }
        }
      }

      img {
        margin-top: 1rem;
        width: 100px;
      }
    }
  }
}
@media screen and (min-width: 641px) {
  footer {
    .links-wrapper {
      .links-container {
        flex-direction: row;
        justify-content: space-between;
        ul {
          flex-direction: row;
          li {
            margin-bottom: 1em;
            a {
              font-size: 14px;
              line-height: 22px;
              margin-right: 2rem;
            }
          }
        }
        img {
          margin-left: 1rem;
          width: 120px;
        }
      }
    }
  }
}
@media screen and (min-width: 1281px) {
  footer {
    .links-wrapper {
      .links-container {
        ul {
          li {
            margin-bottom: 1em;
            a {
              font-size: 20px;
              line-height: 30px;
              margin-right: 2rem;
            }
          }
        }
        img {
          margin-left: 1rem;
          width: 160px;
        }
      }
    }
  }
}
</style>
